import React, { useEffect, useState } from "react";
import { TreeViewArrayFromMap } from "./tree-view-array-from-map";
import { getInitialStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-initial-structure-nodeset";
import { PleaseWaitWhileProcessing } from "@src/components/molecules/please-wait-while-processing/please-wait-while-processing";
import { hasInitialStructureLoadCompleted } from "@src/cloud-connect/node-manager/load-our-node-structures";
import { InitialStructureIsNotReadyYetMessageWrapper } from "@src/components/molecules/initial-structure-is-not-yet-ready/initial-structure-is-not-ready-yet-message-wrapper";

export const TreeViewForMapStructure = () => {
  const initialStructureNodeset = getInitialStructureNodeset();
  const [flatArray, setFlatArray] = useState(
    Array.from(
      initialStructureNodeset.getFlatMap()
        ? initialStructureNodeset.getFlatMap().values()
        : [],
    ),
  );
  // tracks whether the background load has completed (with or without data)
  // without this flag, an empty flatArray from a null nodeset is indistinguishable
  // from an in-progress load, and the spinner would never stop.
  // initialized from the module-level flag so remounting after a completed load
  // (e.g. switching tabs and back) doesn't reset to the spinner state
  const [isLoaded, setIsLoaded] = useState(hasInitialStructureLoadCompleted);

  useEffect(() => {
    const updateFlatMap = () => {
      const newFlatMap = initialStructureNodeset.getFlatMap();
      setFlatArray(Array.from(newFlatMap ? newFlatMap.values() : []));
      setIsLoaded(true);
    };

    initialStructureNodeset.addObserver(updateFlatMap);

    return () => {
      initialStructureNodeset.removeObserver(updateFlatMap);
    };
  }, [initialStructureNodeset]);

  return (
    <>
      {!isLoaded && <PleaseWaitWhileProcessing />}
      {isLoaded && flatArray.length === 0 && (
        <InitialStructureIsNotReadyYetMessageWrapper />
      )}
      {isLoaded && flatArray.length > 0 && (
        <TreeViewArrayFromMap data={flatArray} type="initial" />
      )}
    </>
  );
};
